import { fetch, Uri } from '../utils/fetch';
import packageModel from '../models/package';

export const fetchHotels = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;
  const query = {
    ...packageModel,
    userId,
    siteId,
    ...(siteId === 18 && { showAll: true }),
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/package/hotels', query });
  const response = await fetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export const fetchUpsell = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;
  const query = {
    ...packageModel,
    userId,
    siteId,
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/package/upsell', query });
  const response = await fetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export const fetchPriceMatrix = async (siteSettings, userId) => {
  const { siteId, apiUrl, HotelId, baseUrl, newCheckout } = siteSettings;
  const query = {
    ...packageModel,
    userId,
    siteId,
    newCheckout,
    ...(siteId === 18 && { showAllRooms: true }),
  };

  // If hotelId not in browser url, use hotelId from req.query from Idun.
  if (!query.hotelId && HotelId) {
    query.hotelId = HotelId;
  }

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/package/price-matrix',
    query,
  });

  const response = await fetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export const fetchFlights = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl, newCheckout } = siteSettings;
  const query = {
    ...packageModel,
    userId,
    siteId,
    newCheckout,
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/package/flights', query });
  const response = await fetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export const addPackageToCart = async (model, siteSettings) => {
  const { apiUrl, baseUrl } = siteSettings;

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/package/addToCart',
    query: model,
  });

  const response = await fetch.getJsonByProxy(uri, baseUrl);

  return response;
};
